import request from '@/utils/request'

const Api = {
    GetProvice: '/Province/GetList', // 获取省份信息
}

// 获取省份信息
export function GetProvice() {
    return request({
        url: Api.GetProvice,
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/province.js